import PropTypes from 'prop-types';

import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import ListItemText from '@zenbusiness/zui/ListItemText';

/**
 * BulletList Component
 * Displays a simple bulleted list using ZUI List component
 * Can be used for key findings, features, benefits, or any bulleted list
 *
 * @param {object} props - Component props
 * @param {Array<string|object>} props.content - Array of items (strings or objects with primary/secondary)
 */
function BulletList({ content }) {
  if (!content || !Array.isArray(content) || content.length === 0) {
    return null;
  }

  return (
    <List
      dense
      sx={{
        listStyleType: 'disc',
        pl: 2,
        '& .MuiListItem-root': {
          display: 'list-item',
          px: 0,
          py: 0.5
        }
      }}
    >
      {content.map((item, index) => {
        // Handle both string items and object items with primary/secondary
        const isObject = typeof item === 'object' && item !== null;

        return (
          <ListItem key={index}>
            <ListItemText
              primary={isObject ? item.primary : undefined}
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: 500
              }}
              secondary={isObject ? item.secondary : item}
              secondaryTypographyProps={{
                variant: 'body2'
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );
}

BulletList.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        primary: PropTypes.string,
        secondary: PropTypes.string
      })
    ])
  ).isRequired
};

export default BulletList;
